import { MantineColor, Menu, Text } from '@mantine/core';
import { getFinalSelectionCount } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils';
import { Table } from '@tanstack/react-table';
import { RecordAny } from '@dealstack/shared/lib/common/common';

export interface Props<T extends RecordAny> {
	label: string;
	callback: () => void;
	color?: MantineColor;
	showBulkActionItemCount?: boolean;
	table?: Table<T>;
	disabled?: boolean;
	isHolding?: boolean;
	dataTestId?: string;
}

export const DropdownMenuItem = <T extends RecordAny>({
	label,
	color = 'gray',
	callback,
	showBulkActionItemCount,
	table,
	disabled,
	isHolding = false,
	dataTestId,
}: Props<T>) => {
	return (
		<Menu.Item
			disabled={disabled}
			color={color}
			sx={(theme) => ({
				padding: theme.spacing.xs,
				opacity: disabled ? 0.5 : 1,
			})}
			onClick={callback}
			data-testid={dataTestId}
		>
			<Text size="B6Medium" c={color === 'red' ? 'red.6' : 'dark.9'}>
				{`${label} ${
					showBulkActionItemCount && table && !isHolding
						? `(${getFinalSelectionCount(table)})`
						: ''
				}`}
			</Text>
		</Menu.Item>
	);
};
